/**
 * Maps a @vista-digital/ocapi-types CastAndCrew entity to a schema.org/Person type.
 */
export const mapCastAndCrewMemberToPersonSchema = (member, i18n) => {
    var _a;
    return {
        '@type': 'Person',
        name: (_a = i18n.personName(member.name)) !== null && _a !== void 0 ? _a : '',
        givenName: member.name.givenName,
        familyName: member.name.familyName
    };
};
/**
 * Maps an array of @vista-digital/ocapi-types CastAndCrew entities to a schema.org/Person array or single Person entity.
 */
export const mapCastAndCrewMembersToPersonSchema = (members, i18n) => {
    const people = members.map(member => mapCastAndCrewMemberToPersonSchema(member, i18n));
    return people.length === 1 ? people[0] : people;
};
